import React from 'react'
import {Icon} from 'startlibs/lib/components'
import {en_US, dicomDateToDate, formatDate} from 'report-components'

export const ReportInfoCard = ({report}) => {
  const studyToDate = dicomDateToDate(report.studydate)
  const studydate = isNaN(studyToDate.getTime()) ? report.studydate : formatDate(studyToDate, en_US, 'L dd, yyyy')
  const lastSaved = formatDate(new Date(report.lastSaved), en_US, 'L dd, yyyy - hh:mm')

  return <div className="card with-icon dialog-version">
    <div className="card-content">
      <div className="card-icon"><Icon icon={report.finished ? 'checked-report' : 'report'}/></div>
      <div className="card-title">{report.patientName}</div>
      <div className="card-detail"><b>Study: </b>{report.studydesc} ({studydate})</div>
      <div className="card-detail"><b>Referred by: </b>{report.refphysician ? (report.refphysician) : "Unknown"}</div>
    </div>
    <div hidden className="card-footer">{(report.finished ? 'Finished on ' : 'Last draft saved on ') + lastSaved}</div>
  </div>
}



// WEBPACK FOOTER //
// ./src/javascripts/dashboard/ReportInfoCard.jsx